
/**
 * @description 解决js计算精度问题
 */

// 加法
const calculateAdd = (arg1, arg2) => {
  arg1 = parseFloat(arg1) || 0
  arg2 = parseFloat(arg2) || 0
  let r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 减法
const calculateSub = (arg1, arg2) => {
  arg1 = parseFloat(arg1) || 0
  arg2 = parseFloat(arg2) || 0
  let r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  n = (r1 >= r2) ? r1 : r2
  return Number(((arg1 * m - arg2 * m) / m).toFixed(n))
}

// 乘法
const calculateMul = (arg1, arg2) => {
  arg1 = parseFloat(arg1) || 0
  arg2 = parseFloat(arg2) || 0
  let m = 0
  const s1 = arg1.toString()
  const s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// 除法
const calculateDivision = (arg1, arg2) => {
  arg1 = parseFloat(arg1) || 0
  arg2 = parseFloat(arg2) || 0
  if (arg2 === 0) {
    return 0 // 分母为0时返回0
  }
  let t1 = 0, t2 = 0, r1, r2
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) {}
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) {}
  r1 = Number(arg1.toString().replace('.', ''))
  r2 = Number(arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}

export {
  calculateAdd,
  calculateSub,
  calculateMul,
  calculateDivision
}
